<template>
	<div class="cylsxyqfg-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">{{ youshiInfo.title || '' }}</div>
				<div class="des">以“四个统一”筑牢集装箱行业绿色低碳发展基础</div>
				<!-- 				<div class="des">{{ youshiInfo.des || '' }}</div> -->
			</div>
		</div>
		<div class="main">
			<div class="main-container w1260">
				<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
					<div class="section-1">
						<div class="left-module">
							<div class="heading">实现“四个统一”</div>
							<!-- <div class="heading-des">是连接企业绿色生产与消费者低碳消费的重要桥梁</div> -->
							<div class="list">
								<div class="item">
									<div class="serial">1</div>
									<div class="content">
										<div class="label">产品碳足迹核算模型统一</div>
										<!-- <div class="value">主动公开碳排放数据，传递绿色生产理念，强化品牌环保形象与社会信任度</div> -->
									</div>
								</div>
								<div class="item">
									<div class="serial">2</div>
									<div class="content">
										<div class="label">碳排放因子库统一</div>
									</div>
								</div>
								<div class="item">
									<div class="serial">3</div>
									<div class="content">
										<div class="label">产品碳标签统一</div>
									</div>
								</div>
								<div class="item">
									<div class="serial">4</div>
									<div class="content">
										<div class="label">绿色产品评价体系统一</div>
									</div>
								</div>
							</div>
						</div>
						<div class="right-module scale-img">
							<img class="img" src="@/assets/tmp/053.png" alt="" />
						</div>
					</div>
				</div>
				<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
					<div class="section-2">
						<!-- 获证企业 -->
						<div class="huozhengqiye">
							<div class="huozhengqiye-container">
								<div class="header">
									<div class="title">参与主体广泛</div>
								</div>
								<div class="body">
									<vue-seamless-scroll :data="companyList" :class-option="classOption" class="warp">
										<div class="list">
											<div v-for="(item, index) in companyList" :key="index" @click="companyClick(item)">
												<div :title="item.cnName" class="list-item scale-img">
													<img class="img" :src="item.url" alt="" />
												</div>
											</div>
										</div>
									</vue-seamless-scroll>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import { CompanyListByCooperation } from '@/common/api.js';
import { webInfo } from '@/common/data.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
import { WOW } from 'wowjs';
export default {
	name: 'cylsxyqfg',
	components: { Head, Foot },
	data() {
		return {
			youshiInfo: webInfo.pingtaiyoushi[1],
			// 企业列表
			companyList: [],
			// 无缝滚动配置
			classOption: {
				limitMoveNum: 5,
				direction: 2
			},
		};
	},
	created() {
		this.getCompanyListByCooperation();
	},
	mounted() {
		this.$nextTick(() => {
			new WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 100,
				mobile: true,
				live: true,
				// callback: function (c) {
				//     console.log(c, 'sss')
				// },
				scrollContainer: null,
				resetAnimation: true
			}).init();
		});
	},
	methods: {
		backHead() {
			this.$router.go(-1);
		},
		//获取企业列表
		getCompanyListByCooperation() {
			CompanyListByCooperation().then((res) => {
				// this.companyList = chunkArray([...companyIcons, ...companyIcons], 2);
				// return;
				this.companyList = res.data;
				// this.companyList = chunkArray(res.data, 2);
			});
		},
	}
};
</script>

<style lang="scss" scoped>
.cylsxyqfg-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	position: relative;
	.banner {
		// margin-top: -$head-height;
		// background-image: url('~@/assets/tmp/027.png');
		background-size: cover;
		height: 233px;
		background-color: #29965c;
		.content {
			display: flex;
			flex-direction: column;
			padding-left: 50px;
			padding-right: 50px;
			box-sizing: border-box;
			.heading {
				margin-top: 87px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 36px;
				color: #ffffff;
				line-height: 52px;
				text-align: center;
			}
			.des {
				margin-top: 17px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 18px;
				color: #ffffff;
				line-height: 22px;
				text-align: center;
			}
		}
	}

	.main {
		.main-container {
			display: flex;
			flex-direction: column;
			.features {
				display: flex;
				justify-content: space-between;
				border-bottom: 1px dashed rgba(#080a52, 0.2);
				.item {
					display: flex;
					padding: 68px 0;
					.svg-icon {
						margin-top: 13px;
						margin-right: 37px;
						width: 80px;
						height: 80px;
					}
					.content {
						display: flex;
						flex-direction: column;
						width: 292px;
						.label {
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 24px;
							color: #262729;
							line-height: 33px;
						}
						.value {
							margin-top: 17px;
							font-size: 14px;
							color: #636d7e;
							line-height: 20px;
						}
					}
				}
			}
			.section-1 {
				display: flex;
				padding-bottom: 96px;
				.left-module {
					display: flex;
					flex-direction: column;
					flex: 1;
					padding-right: 36px;
					.heading {
						margin-top: 91px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 28px;
						color: #000000;
						line-height: 52px;
					}
					.heading-des {
						margin-top: 22px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 17px;
						color: rgba(#262729, 0.7);
						line-height: 24px;
					}
					.list {
						margin-top: 71px;
						display: flex;
						flex-direction: column;
						.item {
							margin-bottom: 40px;
							display: flex;
							align-items: center;
							&:last-child {
								margin-bottom: 0;
							}
							.serial {
								margin-right: 23px;
								// margin-top: 7px;
								width: 40px;
								height: 40px;
								background: #29965C;
								border-radius: 50%;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 23px;
								color: #ffffff;
								line-height: 40px;
								text-align: center;
							}
							.content {
								flex: 1;
								display: flex;
								flex-direction: column;
								.label {
									font-family: PingFangSC, PingFang SC;
									font-weight: 500;
									font-size: 21px;
									color: #262729;
									line-height: 29px;
								}
								.value {
									margin-top: 8px;
									font-family: PingFangSC, PingFang SC;
									font-weight: 500;
									font-size: 15px;
									color: rgba(#262729, 0.7);
									line-height: 21px;
								}
							}
						}
					}
				}
				.right-module {
					margin-top: 91px;
					border-radius: 20px;
					img {
						width: 599px;
						height: 425px;
						border-radius: 20px;
					}
				}
			}
			.section-2 {
				display: flex;
				padding-bottom: 80px;
				// 获证企业
				.huozhengqiye {
					width: 100%;
					background-color: #ffffff;
					.huozhengqiye-container {
						// padding: 30px 0 60px;
						.header {
							margin: 0 0 10px;
							.title {
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 28px;
								color: #000000;
								line-height: 52px;
							}
							.des {
								font-weight: bold;
								font-size: 40px;
								color: #000000;
								line-height: 56px;
								
							}
						}
						.body {
							.warp {
								height: calc((96px * 1) + (50px * 1));
								overflow: hidden;
							}
							.list {
								display: flex;
								height: calc((96px * 1) + (50px * 1));
								.list-item {
									width: 232px;
									height: 96px;
									background: #ffffff;
									border: 1px solid #f2f2f2;
									box-sizing: border-box;
									display: flex;
									justify-content: center;
									align-items: center;
									padding: 0 20px;
									margin-top: 50px;
									margin-right: 50px;
									cursor: pointer;
									img {
										width: 100%;
										height: 100%;
										object-fit: contain;
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>
